export default "__VITE_ASSET__BlKTvEIz__"